/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetOrderbookStatsOptions,
  GetOrderbookStatsResponses,
} from '../types/GetOrderbookStats'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get orderbook stats
 * {@link /v1/orderbooks/:order_book_id/stats}
 */
export function getOrderbookStats<ThrowOnError extends boolean = true>(
  options: Options<GetOrderbookStatsOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetOrderbookStatsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/orderbooks/{order_book_id}/stats',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetOrderbookStatsResponses, ThrowOnError>>,
  )
}
